<template>
  <div @click="open">
    <slot />
  </div>
</template>

<script>
import { Uppload, en, Local, Preview, Crop } from "uppload";
import "uppload/dist/uppload.css";
import "uppload/dist/themes/light.css";

export default {
  name: "Uppload",
  props: {
    uploader: Function
  },
  data: () => ({}),
  created() {
    if (!this.uppload) {
      this.uppload = new Uppload({
        lang: en,
        call: ".add-outfit-btn",
        bind: ".uppload-image",
        uploader: this.uploader,
        maxSize: [1000, 800]
      });
      // Services
      this.uppload.use([new Local()]);

      // Effects
      this.uppload.use([new Preview(), new Crop()]);

      this.uppload.on("upload", url => this.$emit("input", url));
    }
  },
  methods: {
    open() {
      this.uppload.open();
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/showCapsule/Uppload.vue